/*
 * Copyright (c) 2022. 42 bv (www.42.nl). All rights reserved.
 */
"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:diceCalculateBulkChange
 */
angular.module("diceApp").component("diceCalculateBulkChange", {
  bindings: {
    type: "<",
    evaluations: "<",
    onChange: "&",
    onCancel: "&"
  },
  templateUrl: "es6/evaluations/bulk/calculate.bulk.change.html",
  controllerAs: "calculateBulkChangeController",
  controller: function (Evaluation, message) {
    const calculateBulkChangeController = this;

    calculateBulkChangeController.submit = function () {
      calculate();
    };

    function calculate() {
      calculateBulkChangeController.loading = true;

      Evaluation.bulkCalculate({
        evaluationIds: _.map(calculateBulkChangeController.evaluations, "id")
      })
        .$promise.then((result) => {
          message.addInfoLabel("Message.BulkCalculated");
          calculateBulkChangeController.onChange({ result });
        })
        .finally(() => {
          calculateBulkChangeController.loading = false;
        });
    }
  }
});
